var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineBitcoinCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 9.25c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h11c.41 0 .75.34.75.75s-.34.75-.75.75H2zM6 17.25c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2c.41 0 .75.34.75.75s-.34.75-.75.75H6zM10.5 17.25c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h4c.41 0 .75.34.75.75s-.34.75-.75.75h-4z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.44 21.25c-3.98 0-5.19-1.2-5.19-5.14V7.89c0-3.94 1.21-5.14 5.19-5.14h6.84c.41 0 .75.34.75.75s-.34.75-.75.75H6.44c-3.14 0-3.69.54-3.69 3.64v8.22c0 3.1.55 3.64 3.69 3.64h11.12c3.14 0 3.69-.54 3.69-3.64v-4.78c0-.41.34-.75.75-.75s.75.34.75.75v4.78c0 3.94-1.21 5.14-5.19 5.14H6.44z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 6.5c-.41 0-.75-.34-.75-.75v-2.5c0-.41.34-.75.75-.75h3.13c1.07 0 2 .93 2 2-.01 1.1-.9 2-2.01 2H17zM20.13 5c.28 0 .5-.22.5-.5 0-.22-.24-.5-.5-.5h-2.38v1h2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 9c-.41 0-.75-.34-.75-.75v-2.5c0-.41.34-.75.75-.75h3.57c1.2 0 2.18.9 2.18 2s-.98 2-2.18 2H17zm3.57-1.5c.37 0 .68-.23.68-.5s-.31-.5-.68-.5h-2.82v1h2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.01 9.5V8.25c0-.41.34-.75.75-.75s.75.34.75.75V9.5c0 .42-.33.75-.75.75-.41 0-.75-.34-.75-.75zM18.01 3.25V2c0-.41.34-.75.75-.75s.75.34.75.75v1.25a.749.749 0 1 1-1.5 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 4c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2.19c.41 0 .75.34.75.75s-.34.75-.75.75H16zM16 9c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2.19c.41 0 .75.34.75.75s-.34.75-.75.75H16z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineBitcoinCard);
export default __webpack_public_path__ + "static/media/vuesax-outline-bitcoin-card.91002cbf92ffdd9c5bffa7d78535f67d.svg";
export { ForwardRef as ReactComponent };